var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
var DEFAULT_SKELETON_AS = "div";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export var Skeleton = function (_a) {
    var as = _a.as, height = _a.height, _b = _a.width, width = _b === void 0 ? "100%" : _b, _c = _a.radius, radius = _c === void 0 ? 4 : _c, style = _a.style, className = _a.className, children = _a.children, // in case for some reason, someone wants something inside the skeleton
    rest = __rest(_a, ["as", "height", "width", "radius", "style", "className", "children"]);
    var Tag = as || DEFAULT_SKELETON_AS;
    var innerStyles = {
        borderRadius: "var(--eds-radii-".concat(radius, ")"),
        height: height,
        width: width,
    };
    return (_jsx(Tag, __assign({ style: __assign(__assign({}, innerStyles), style), className: classNames("eds-skeleton", className) }, rest, { children: children })));
};
